/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsPreview,
    MelcoModelsPreviewFromJSON,
    MelcoModelsPreviewFromJSONTyped,
    MelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsUserAlphabet
 */
export interface MelcoModelsUserAlphabet {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    style?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserAlphabet
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    service_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    recommended_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    file_name: string;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserAlphabet
     */
    file_size: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    original_file_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserAlphabet
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserAlphabet
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsUserAlphabet
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsUserAlphabet
     */
    publish_state?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserAlphabet
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsUserAlphabet
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {Array<MelcoModelsPreview>}
     * @memberof MelcoModelsUserAlphabet
     */
    previews?: Array<MelcoModelsPreview> | null;
}

export function MelcoModelsUserAlphabetFromJSON(json: any): MelcoModelsUserAlphabet {
    return MelcoModelsUserAlphabetFromJSONTyped(json, false);
}

export function MelcoModelsUserAlphabetFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserAlphabet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'style': !exists(json, 'style') ? undefined : json['style'],
        'service_id': !exists(json, 'service_id') ? undefined : json['service_id'],
        'service_name': !exists(json, 'service_name') ? undefined : json['service_name'],
        'recommended_text': !exists(json, 'recommended_text') ? undefined : json['recommended_text'],
        'type': json['type'],
        'signature': json['signature'],
        'file_name': json['file_name'],
        'file_size': json['file_size'],
        'original_file_name': !exists(json, 'original_file_name') ? undefined : json['original_file_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(MelcoModelsPreviewFromJSON)),
    };
}

export function MelcoModelsUserAlphabetToJSON(value?: MelcoModelsUserAlphabet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'style': value.style,
        'service_id': value.service_id,
        'service_name': value.service_name,
        'recommended_text': value.recommended_text,
        'type': value.type,
        'signature': value.signature,
        'file_name': value.file_name,
        'file_size': value.file_size,
        'original_file_name': value.original_file_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'publish_state': value.publish_state,
        'rfm_url': value.rfm_url,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(MelcoModelsPreviewToJSON)),
    };
}


